export class McRAIImage {
  constructor(
    public path: string,
    public width: number,
    public height: number
  ) { }
}
